<template>
    <section class="checkobx-wrapper">
        <input type="checkbox"
               :value="value"
               class="checkobx-btn"
               :id="id"
                :disabled="disable"
               @change="handleChange"
               :checked="checked" />
        <section class="checkbox-mark" :class="{ 'checkbox-mark--disabled': disable }">
            <img src="../../assets/icons/components/accept-mark.svg" />
        </section>
    </section>
</template>

<script>export default {
    name: "CheckBoxButtonSingleUnchecked",
    props: {
        value: [Number, String],
        id: [Number, String],
        checked: Boolean,
        disable: {
            type: Boolean,
            default: false,
        }
    },
    methods: {
        handleChange(e) {
            if(this.disable) {
                return;
            }
            this.$emit("setChecked", parseInt(e.target.value));
        },
    },
};</script>

<style lang="scss" scoped>
    .checkobx-wrapper {
        position: relative;
    }

    .checkobx-btn {
        width: 24px;
        height: 24px;
        position: relative;
        opacity: 1;

        &:checked ~ .checkbox-mark {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        &:checked ~ .add-contact-form__label--checkbox {
            padding-left: 0px;
        }

        &:before {
            content: "";
            background: #ffffff;
            border: 1px solid #d1d6df;
            box-sizing: border-box;
            box-shadow: 1px 1px 2px rgba(0, 8, 44, 0.06);
            /*border-radius: 4px;*/
            width: 24px;
            height: 24px;
            position: relative;
            display: block;
            top: 0px;
            left: 0px;
            opacity: 1;
            z-index: 2;
        }
            &:disabled {
                background: red;
            }
    }

    .checkbox-mark {
        background: #00082c;
        border: 1px solid #00082c;
        box-sizing: border-box;
        box-shadow: 1px 1px 2px rgba(0, 8, 44, 0.06);
        border-radius: 4px;
        width: 24px;
        height: 24px;
        position: absolute;
        z-index: 5;
        display: none;
        top: 0px;
        left: 0px;
        opacity: 1;

        &--disabled {
            background: #7e7e7e;
            border: 1px solid #d1d6df;
            box-shadow: 1px 1px 2px rgba(0, 8, 44, 0.06);
        }
    }
</style>
